import { API_URLs } from "../../../../utilities/API_URLs";
import { Http } from "../../../../utilities/axios/http";

export class BookingService {
    static getBookingList = async (params?: any) => {
        try {
            return await Http.get(API_URLs.booking.bookingUrl, params)
        } catch (error) {
            return error;
        }
    }

    static getBookingById = async (id: number) => {
        try {
            return await Http.get(`${API_URLs.booking.bookingUrl}/${id}`)
        } catch (error) {
            return error;
        }
    }

    static createBooking = async (data: any) => {
        try {
            return await Http.post(API_URLs.booking.bookingUrl, data);
        } catch (error) {
            return error;
        }
    }

    static getBookingSource = async (params?: any) => {
        try {
            return await Http.get(API_URLs.booking.bookingSourceUrl, params)
        } catch (error) {
            return error;
        }
    }

    static getStorageLoads = async (params?: any) => {
        try {
            return await Http.get(`${API_URLs.transports.selectStorage}`, params)
        } catch (error) {
            return error;
        }
    }
}